<template>
  <div class="ratings">
    <div class="flex align-center title">
      <h2>{{ info.language_list.ratings.title }}</h2>
      <i
        class="iconfont icon-youjiantou"
        @click="handleConfirm"></i>
    </div>
    <p>
      {{ info.language_list.ratings.describe }}
    </p>
    <div
      class="flex align-center justify-between verified-box"
      v-if="info.template_id === 5">
      <span class="comment">{{ info.comment }}</span>
      <p class="verified">
        <span>{{ info.language_list.ratings.verified }}</span>
        <i class="iconfont icon-gantanhao"></i>
      </p>
    </div>
    <div class="ratings-box flex justify-between align-center">
      <div class="score">
        <div class="score-num">{{ info.score }}</div>
        <Star :score="info.score"></Star>
      </div>
      <div class="score-bar">
        <div
          class="score-item flex align-center"
          v-for="(item, index) in info.score_detail"
          :key="index">
          <span>{{ item.label }}</span>
          <div class="score-bg">
            <div :style="{ width: `${item.value}%` }"></div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="info.template_id !== 5"
      :class="[
        'flex',
        'justify-between',
        info.template_id === 1 || info.template_id === 5
          ? 'fl-row'
          : 'fl-column',
      ]">
      <span class="comment">{{ info.comment }}</span>
      <p class="verified">
        <span>{{ info.language_list.ratings.verified }}</span>
        <i class="iconfont icon-gantanhao"></i>
      </p>
    </div>
    <div
      class="ratings-list"
      v-if="info.template_id !== 5">
      <div
        v-for="(item, index) in info.comment_list"
        :key="index"
        class="ratings-item">
        <div class="user-info flex justify-between align-center">
          <div
            class="flex align-center"
            @click="handleConfirm">
            <img
              class="user-header"
              :src="item.head_url"
              alt="" />
            <span>{{ item.user_name }}</span>
          </div>
          <div
            class="iconfont icon-gengduo1 more"
            @click="handleConfirm"></div>
        </div>
        <div class="ratings-time flex align-center">
          <Star :score="item.score"></Star>
          <div class="time">
            {{ item.time }}
          </div>
        </div>
        <div class="ratings-content">
          {{ item.content }}
        </div>
        <div class="ratings-helpful flex align-center">
          <div class="ratings-text">
            {{ info.language_list.ratings.helpful }}
          </div>
          <div class="btns">
            <span @click="handleConfirm">
              {{ info.language_list.ratings.yes }}</span
            >
            <span @click="handleConfirm">{{
              info.language_list.ratings.no
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else
      class="ratings-box">
      <ul>
        <li
          v-for="(item, index) in info.comment_list"
          :key="index"
          class="ratings-item">
          <div class="item-tit flex align-center">
            <img
              :src="item.head_url"
              alt="" />
            <span>{{ item.title }}</span>
          </div>
          <div class="flex align-center">
            <Star :score="item.score"></Star>
            <span class="user">{{ item.user_name }}</span>
          </div>
          <div class="content">{{ item.content }}</div>
          <div class="ratings-helpful flex align-center">
            <div class="ratings-text">
              {{ info.language_list.ratings.helpful }}
            </div>
            <div class="btns flex">
              <span @click="handleConfirm">
                {{ info.language_list.ratings.yes }}</span
              >
              <span @click="handleConfirm">{{
                info.language_list.ratings.no
              }}</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <p
      @click="handleConfirm"
      :class="[
        'flag',
        'flex',
        'align-center',
        info.template_id === 2 || info.template_id === 5
          ? 'fl-start'
          : 'fl-end',
      ]">
      <span>{{ info.language_list.ratings.see_all_reviews }}</span>
      <i class="iconfont icon-yanjing"></i>
    </p>
    <p
      @click="handleConfirm"
      :class="[
        'flag',
        'flex',
        'align-center',
        info.template_id === 2 || info.template_id === 5
          ? 'fl-start'
          : 'fl-end',
      ]">
      <span>{{ info.language_list.ratings.flag }}</span>
      <i class="iconfont icon-icon-test"></i>
    </p>
  </div>
</template>
<script setup>
import Star from '@/components/Star';

import { computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();
const info = computed(() => store.state.appInfo);

const emit = defineEmits(['confirm']);

const handleConfirm = () => {
  emit('confirm');
};
</script>
<style lang="scss">
.template-3 .verified,
.template-4 .verified {
  text-align: right;
}
</style>
<style lang="scss" scoped>
.ratings {
  margin: 24px 0;
  h2 {
    color: #202124;
  }
  .score-item {
    height: 16px;

    span {
      padding-right: 16px;
    }
  }
  .ratings-box {
    margin-top: 20px;
    padding-bottom: 10px;
  }
  .fl-row {
    align-items: center;
  }
  .score {
    display: flex;
    flex-direction: column;
    justify-content: center;
    .score-num {
      margin: 20px 0 20px 0;
      font-weight: 400;
      font-family: 'Google Sans Display', Roboto, Arial, sans-serif;
      color: rgb(32, 33, 36);
      font-size: 40px;
    }
  }
  .comment {
    font-size: 12px;
    padding-top: 5px;
    text-align: left;
    color: #333;
  }

  .verified-box {
    margin-top: 10px;
  }
  .verified {
    color: var(--main-color);
    font-size: 12px;
    span {
      padding-right: 5px;
    }
  }
  .score-bg {
    width: 180px;
    background-color: rgb(232, 234, 237);
    border-radius: 9999px;
    height: 10px;
    position: relative;
    div {
      position: absolute;
      background-color: var(--main-color);
      border-radius: 9999px;
      height: 10px;
    }
  }

  .ratings-list {
    .ratings-item {
      padding: 16px 0;
      .user-info {
        position: relative;
        span {
          color: #202124;
          font-size: 14px;
        }
        .more {
          font-size: 16px;
          text-align: center;
          line-height: 30px;
          width: 30px;
          height: 30px;
          background-color: #fff;
          border-radius: 50%;
          text-align: center;
          position: absolute;
          right: -10px;
          &:hover {
            background-color: #f6f6f6;
          }
        }
      }
      .user-header {
        border-radius: 50%;
        width: 32px;
        height: 32px;
        overflow: hidden;
        background-size: cover;
        margin-right: 16px;
      }
      .ratings-content {
        margin-top: 8px;
        font-size: 16px;
        line-height: 30px;
        color: #5f6368;
      }
      .ratings-time {
        font-size: 12px;
        margin-top: 16px;
        .star-rating {
          font-size: 10px;
          .star {
            width: 10px;
            margin-right: 2px;
          }
        }
        .time {
          margin-left: 10px;
        }
      }
    }
  }
  .ratings-helpful {
    margin-top: 12px;
    .ratings-text {
      color: #5f6368;
      font-size: 12px;
      margin-right: 24px;
      max-width: 250px;
    }
    .btns {
      span {
        display: inline-block;
        border: 1px solid #dadce0;
        font-size: 12px;
        border-radius: 9999px;
        padding: 0 15px;
        height: 22px;
        line-height: 22px;
        margin: 0 6px;
        background-color: #fff;
      }
      span:hover {
        color: var(--main-color);
        background-color: #f6f6f6;
        border: none;
        height: 24px;
        line-height: 24px;
      }
    }
  }
  .ratings-box {
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    margin: 12px 0;
    ul {
      display: flex;
      flex-wrap: nowrap;
      padding: 5px 5px 10px 5px;
      width: fit-content;
      margin-left: -5px;
      li {
        padding: 10px 12px;
        margin: 0 8px;
        width: 270px;
        height: 203px;
        border-radius: 12px;
        background: #f5f5f5;
        box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.3);
      }
      .item-tit {
        font-size: 14px;
        color: #333333;
        margin-bottom: 12px;
        img {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          margin-right: 16px;
        }
      }
      .content {
        font-size: 12px;
        margin-top: 12px;
        color: #555555;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 4;
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        height: 80px;
      }
      .user {
        padding-left: 10px;
        color: #555555;
        font-size: 10px;
      }
    }
    .ratings-helpful {
      justify-content: space-between;
      .ratings-text {
        margin-right: 0;
      }
    }
  }

  .flag {
    margin-bottom: 15px;
    span {
      font-size: 12px;
      color: var(--main-color);
      padding-right: 5px;
    }
  }
}
</style>
